import { MethodInfoBlock, methodInfoStyles } from '@/core/components/MethodInfoBlock'
import { TypeLink } from '@/core/components/TypeLink'
import type { ParameterData } from '@/core/types/library.type'

interface MethodParametersProps {
  parameters: ParameterData[]
}

export function MethodParameters({ parameters }: MethodParametersProps) {
  return (
    <MethodInfoBlock title="Parameters">
      <div className={methodInfoStyles.grid}>
        <div className={methodInfoStyles.column}>
          {parameters.map((parameter) => (
            <span key={parameter.name} className={methodInfoStyles.valueName}>
              {parameter.name}:
            </span>
          ))}
        </div>
        <div className={methodInfoStyles.column}>
          {parameters.map((parameter) => (
            <TypeLink key={parameter.name} typeName={parameter.type} typeUsage={parameter.typeUsage} />
          ))}
        </div>
      </div>
    </MethodInfoBlock>
  )
}
